import React from 'react';
import { OrganizersStatsSection as OrganizersStatsSectionImpl } from './stats.sections';

export default function OrganizersStatsSection(props) {
    return <OrganizersStatsSectionImpl {...props} />;
}
